import { SizingWrapperStyle } from "@/components/Wrapper";
import { Box, TablePagination } from "@mui/material";
import { Button, ButtonVariantOption } from "@/components/Button";
import { GridToolbarContainer } from "@mui/x-data-grid";

interface IProps {
  page: number;
  pageSize: number;
  allCount: number;
  rowsPerPageOptions: number[];
  disabledAcquireMultipleBooksButton: boolean;
  changePage: (pageIndex: number) => void;
  changePageSize: (pageSize: number) => void;
  handleClickAcquireButton: () => void;
}

const CustomToolbar: React.FC<IProps> = (props) => {
  const {
    page,
    pageSize,
    allCount,
    rowsPerPageOptions,
    disabledAcquireMultipleBooksButton,
    changePage,
    changePageSize,
    handleClickAcquireButton,
  } = props;

  return (
    <>
      <GridToolbarContainer
        sx={{ p: 0, display: "flex", justifyContent: "space-between" }}
      >
        {/* 登記一括取得ボタン */}
        <Box ml={1}>
          <Button
            label="登記一括取得"
            onClick={handleClickAcquireButton}
            variant={ButtonVariantOption.Contained}
            size={SizingWrapperStyle.MEDIUM}
            disabled={disabledAcquireMultipleBooksButton}
          />
        </Box>
        {/* 上部のページネーション */}
        <TablePagination
          component={"div"}
          count={allCount}
          page={page}
          rowsPerPageOptions={rowsPerPageOptions}
          onPageChange={(_, page) => {
            changePage(page);
          }}
          rowsPerPage={pageSize}
          onRowsPerPageChange={(event) => {
            changePageSize(Number(event.target.value));
          }}
          labelRowsPerPage={"ページあたりの行数:"}
          labelDisplayedRows={({ from, to, count }) => {
            return `${from.toLocaleString()}〜${to.toLocaleString()} / ${count.toLocaleString()}`;
          }}
        />
      </GridToolbarContainer>
    </>
  );
};

export { CustomToolbar };
